import { AppState } from '../../../redux/reducers';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';

interface IProps {
    SettlementId: number;
}

interface ConnectedProps {
    Settlement: Settlement | undefined;
    accessToken: string | undefined;
    /** Cambia cuando la liquidación se recalculó o cambió de estado: hay que releer el desglose. */
    refreshKey: string;
}

export type Props = IProps & ConnectedProps;

export const mapStateToProps = (state: AppState, ownProps: IProps): ConnectedProps => {
    const settlement = state.Settlement?.list?.find((item: Settlement) => item.id === ownProps.SettlementId);
    const totalsKey = (settlement?.totals ?? []).map((total) => `${total.currencyCode}:${total.totalValue}`).join('|');
    return {
        Settlement: settlement,
        accessToken: state.oidc?.user?.access_token,
        refreshKey: `${settlement?.status ?? ''}|${settlement?.isRecalculating ? 'r' : ''}|${settlement?.details?.length ?? 0}|${totalsKey}`
    };
};

export const mapDispatchToProps = {};
